import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  LogOut,
  Home,
  Bell,
  // Shield,
  User,
  Activity,
  // BarChart2,
  HelpCircle
} from 'react-feather';
import { NavLink } from 'react-router-dom';
import { logout } from '../../services/authService';
import ProfilePane from './profilePane';
// import Statistics from './img/Watchtower.png';
import ReactTooltip from 'react-tooltip';
import { mobile } from './../../utils/constants';

async function LogOutAction() {
  await logout();
  window.location = '/login';
}

const NavBar = (props) => {
  const { value } = props;
  const { is_superuser = true } = value;
  const { first_name, last_name } = value;
  const shortname = first_name ? first_name[0] + last_name[0] : '';

  //Profile Pane States
  const [profileshow, setProfileShow] = useState(false);
  const handleProfileClose = () => setProfileShow(false);
  const handleProfileShow = () => setProfileShow(true);

  return (
    <>
      {!mobile && (
        <>
          <Col xs={12} md={1} lg={1} className='side-navbar d-flex p-0'>
            <Row className='side-navbar-top m-0'>
              <div className='shortname' onClick={handleProfileShow}>
                {shortname.toUpperCase()}
              </div>
              {/* <img
                src={Statistics}
                alt='Watchtower'
                style={{ height: '36px' }}
              /> */}
            </Row>
            <Row className='side-navbar-middle m-0'>
              <NavLink exact to='/home' data-tip='Home'>
                <div className='tile'>
                  <Home />
                  <span className='name'>Home</span>
                </div>
              </NavLink>
              {/* <NavLink to='/dashboard' data-tip='Dashboard'>
                <div className='tile'>
                  <BarChart2 />
                  <span className='name'>KPIs</span>
                </div>
              </NavLink> */}
              <NavLink to='/alerts' data-tip='Security'>
                <div className='tile'>
                  <Bell />
                  <span className='name'>Alerts</span>
                </div>
              </NavLink>
              {is_superuser && (
                <>
                  <NavLink to='/users' data-tip='User'>
                    <div className='tile'>
                      <User />
                      <span className='name'>Users</span>
                    </div>
                  </NavLink>
                  <NavLink to='/usage-report' data-tip='14 days Usage Report'>
                    <div className='tile'>
                      <Activity />
                      <span className='name'>Usage</span>
                    </div>
                  </NavLink>
                </>
              )}
              {/* <NavLink to='/security' data-tip='Security'>
                <div className='tile'>
                  <Shield />
                  <span className='name'>Security</span>
                </div>
              </NavLink> */}
              <NavLink to='/faqs' data-tip='FAQs'>
                <div className='tile'>
                  <HelpCircle />
                  <span className='name'>FAQs</span>
                </div>
              </NavLink>
            </Row>
            <Row className='side-navbar-bottom m-0'>
              <LogOut
                size={17}
                onClick={() => LogOutAction()}
                data-tip='LogOut'
              />
            </Row>
          </Col>
          <ReactTooltip type='light' effect='solid' className='tooltiptheme' />
          <ProfilePane
            user={value}
            show={profileshow}
            handleClose={handleProfileClose}
            handleShow={handleProfileShow}
          />
        </>
      )}
    </>
  );
};

export default NavBar;
